import axios from 'axios';
import { removeToken,removeUserId } from "../auth";
const post_req = async ({request=undefined,logout_on_error = false,return_data=true}) => {const response= await axios.post('https://looply.mogaverocompany.co.ke/api/webs.php',new URLSearchParams(request)
    );
    if (response.data.status === -1004) {
            if (logout_on_error) {
                removeToken(); // Esegue il logout
                removeUserId()
                window.location.href = "/login"; // Reindirizza alla pagina di login
            }
            return null; // Oppure potresti restituire un messaggio d'errore
        }

    if (return_data) {

    return response.data;}
    else {return response}};
export default post_req